import {
  call,
  put,
  takeLatest
} from "redux-saga/effects";
import {
  authorizedRequest
} from "utils/api";
import {
  API_AVPS
} from "constants/apiRoutes";
import {
  ToastSuccess,
  ToastError
} from "components/Global/Toasts/Toasty";

export const AVP_FETCH_REQUEST = "AVP_FETCH_REQUEST";
export const AVP_FETCH_SUCCESS = "AVP_FETCH_SUCCESS";
export const AVP_FETCH_FAILURE = "AVP_FETCH_FAILURE";

const initialState = {};

export default function avpReducer(state = initialState, action) {
  const {
    type,
    payload
  } = action;
  switch (type) {
    case AVP_FETCH_SUCCESS:
      return payload;

    default:
      return state;
  }
}

/**
 * Get all avps
 * @return {Object} Action
 */
export function fetchAvps() {
  return {
    type: AVP_FETCH_REQUEST
  };
}

export function avpFetchSuccess(payload) {
  return {
    type: AVP_FETCH_SUCCESS,
    payload
  };
}

function avpFetchFailure(payload) {
  return {
    type: AVP_FETCH_FAILURE,
    payload
  };
}

// Saga
function* fetchSaga() {
  try {
    const response = yield call(authorizedRequest, API_AVPS);
    yield put(avpFetchSuccess(response));
  } catch (error) {
    yield put(avpFetchFailure(error));
    ToastError(error.message);
  }
}

export function* avpSaga() {
  yield takeLatest(AVP_FETCH_REQUEST, fetchSaga);
}
